/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IThunkApi } from 'shared/types/redux';

/* istanbul ignore next */
export const loadFeatures = createAsyncThunk<string, string, IThunkApi>(
  'demo/loadFeatures',
  async (doneText, _thunkApi) => {
    /**
     * Пример, чтобы показать, что есть в thunkApi
     *
     *    const {
     *      getState,
     *       extra: { config, logger, httpApi },
     *       dispatch,
     *       rejectWithValue,
     *     } = thunkApi;
     */
    const { rejectWithValue } = _thunkApi;

    try {
      const response = await new Promise<string>((resolve, reject) => {
        setTimeout(() => {
          if (Math.round(Math.random())) {
            resolve(doneText);
          }

          reject();
        }, 2000);
      });

      return response;
    } catch (e) {
      /**
       * Используется для проброса данных в payload экшена rejected
       */
      return rejectWithValue(e);
    }
  },
  {
    /**
     * Можно предотвратить вызов thunk-а через специальный объект с условием
     * (полезно, например, в случаях, если идет загрузка и надо предотвратить повторный запрос)
     */
    condition: (_doneText: string, _api) => {
      /**
       * В api есть стейт и extra
       *
       * сonst { getState, extra } = api;
       */
      const { getState } = _api;

      const {
        demo: { test },
      } = getState();

      return test;
    },
  },
);
